import { useEffect } from "react";

interface TitleUpdaterProps {
  title: string;
  description?: string | null;
  keywords?: string | null;
  robots?: string | null;
}

const setCanonical = () => {
  const url = `${window.location.origin}${window.location.pathname}`;
  let el = document.querySelector<HTMLLinkElement>('link[rel="canonical"]');
  if (!el) {
    el = document.createElement("link");
    el.rel = "canonical";
    document.head.appendChild(el);
  }
  el.href = url;
};

// undefined = don't touch, null/empty = remove tag, string = set content
const setMeta = (name: string, content: string | null | undefined) => {
  if (content === undefined) return;
  let el = document.querySelector<HTMLMetaElement>(`meta[name="${name}"]`);
  if (!content) {
    el?.remove();
    return;
  }
  if (!el) {
    el = document.createElement("meta");
    el.name = name;
    document.head.appendChild(el);
  }
  el.content = content;
};


const TitleUpdater: React.FC<TitleUpdaterProps> = ({ title, description, keywords, robots = "index, follow" }) => {
  useEffect(() => {
    document.title = title;
    setMeta("description", description);
    setMeta("keywords", keywords);
    setMeta("robots", robots);
    setCanonical();
  }, [title, description, keywords, robots]);

  return null;
};

export default TitleUpdater;
